import { DynamicContextProvider } from "@dynamic-labs/sdk-react-core";
import { ENV } from "../lib/env";

const DynamicWrapper = ({ children, onAuthSuccess }) => {
  return (
    <DynamicContextProvider
      settings={{
        environmentId: ENV.DYNAMIC_ENVIRONMENT,
        events: {
          onAuthSuccess,
        },
      }}
    >
      {children}
    </DynamicContextProvider>
  );
};
export default DynamicWrapper;
